import React from 'react';

import { Link } from 'react-router-dom'

import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';

const LinkListItem = (props) => {
    const {
        divider,
        selected,
        link,
        label,
        ItemIcon
    } = props;

    if (divider) return <Divider />
    return (
        <ListItemButton
            selected={selected}
            component={Link}
            to={link}
        //   onClick={(event) => handleListItemClick(event, 0)}
        >
            {ItemIcon ? (
                <ListItemIcon>
                    <ItemIcon />
                </ListItemIcon>
            ) : null}
            <ListItemText primary={label}  />
        </ListItemButton>
    )
}

export default LinkListItem